import { Navigate, useNavigate } from "react-router-dom";
import useGetPermission from "../hooks/useGetPermission";
function AuthComponent({
  children,
  action,
  module_name,
  sub_module_name,
  page,
}) {
  const { hasAccess } = useGetPermission();
  const navigate = useNavigate();
  if (!hasAccess(action, module_name, sub_module_name)) {
    return navigate("/access-denied");
  }

  return <>{children}</>;
}

export default AuthComponent;
